import { Route } from "react-router-dom";
import { ProtectedRoute } from "../../routers/protected-route";
import { Round, Rounds, CreateRound, UpdateRound } from "./pages";

export const RoundsRouter = [
  <Route
    path="/rounds"
    element={
      <ProtectedRoute roles={["Any"]}>
        <Rounds />
      </ProtectedRoute>
    }
  />,

  <Route path="/round">
    <Route
      path=":id"
      element={
        <ProtectedRoute roles={["Any"]}>
          <Round />
        </ProtectedRoute>
      }
    />
    ,
    <Route
      path="create"
      element={
        <ProtectedRoute roles={["Any"]}>
          <CreateRound />
        </ProtectedRoute>
      }
    />
    ,
    <Route
      path=":id/update"
      element={
        <ProtectedRoute roles={["Any"]}>
          <UpdateRound />
        </ProtectedRoute>
      }
    />
  </Route>,
];

export const AdminRoundsRouter = [
  <Route
    path="/rounds"
    element={
      <ProtectedRoute roles={["Any"]}>
        <Rounds />
      </ProtectedRoute>
    }
  />,

  <Route path="/round">
    <Route
      path=":id"
      element={
        <ProtectedRoute roles={["Any"]}>
          <Round />
        </ProtectedRoute>
      }
    />
    ,
    <Route
      path="create"
      element={
        <ProtectedRoute roles={["Any"]}>
          <CreateRound />
        </ProtectedRoute>
      }
    />
    ,
    <Route
      path=":id/update"
      element={
        <ProtectedRoute roles={["Any"]}>
          <UpdateRound />
        </ProtectedRoute>
      }
    />
  </Route>,
];

export const ClientSitesRouter = [];
